<template>
  <div>
    <el-card>
      <el-form ref="form" :model="form" label-width="220px" :rules="compRules" class="compForm" @submit.native.prevent>
        <el-form-item label="复合用量：" prop="rfid_comp_phr">
          <el-input
            v-model="form.rfid_comp_phr"
            ref="compRef"
            maxlength="11"
            show-word-limit
            @input="form.rfid_comp_phr = keepNum99(form.rfid_comp_phr)"
            @change="compPhrChange"
          >
            <template slot="append">米</template></el-input
          >
        </el-form-item>
        <el-form-item label="参与复合人：" prop="rfid_take_stff_names">
          <el-select v-model="form.rfid_take_stff_names" multiple placeholder="请选择">
            <el-option v-for="item in stffList" :key="item.stff_name" :label="item.stff_name" :value="item.stff_name"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="填卡人：" prop="card_user_id">
          <el-select v-model="form.card_user_id" filterable placeholder="请选择" disabled>
            <el-option v-for="item in stffList" :key="item.user_id" :label="item.stff_name" :value="item.user_id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="制作人：" prop="stff_id">
          <el-select v-model="form.stff_id" filterable placeholder="请选择">
            <el-option v-for="item in stffList2" :key="item.stff_id" :label="item.stff_name" :value="item.stff_id"> </el-option>
          </el-select>
        </el-form-item>
        <sub-table ref="subTable" :stffList="stffList2" />
        <el-form-item class="ml_10" align="center">
          <el-button @click="submit" type="success" class="determine">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!--   提交 -->
    <el-dialog :visible.sync="compDialogVisible" width="70%">
      <h2 class="diaTitle">提示：提交复合信息, 是否继续</h2>
      <div class="diaContent">
        <el-button @click="compDialogVisible = false" class="determine">取 消</el-button>
        <el-button type="primary" @click="compDialog" class="determine">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post } from '@api/request';
import { rfidAPI } from '@api/modules/rfid';
import helper from '@assets/js/helper';
import SubTable from '@/views/OperateManagement/ReadManage/TabChild/subTable.vue';

export default {
  components: { SubTable },
  data() {
    return {
      form: {
        rfid_comp_phr: '',
        rfid_comp_id: '',
        card_user_id: '',
        stff_id: '',
        rfid_take_stff_names: []
      },
      compRules: {
        rfid_comp_phr: [
          {
            required: true,
            message: '请输入复合用量',
            trigger: 'blur'
          },
          { pattern: /^\d{0,6}(\.\d{1,4})?$/, message: '最大只能输入999999.9999且最多4位小数!' }
        ]
      },
      compDialogVisible: false
    };
  },
  props: {
    prop: {
      type: Object
    },
    stffList: {
      type: Array
    },
    stffList2: {
      type: Array
    }
  },
  created() {
    this.getStffList();
  },
  methods: {
    submit() {
      if (!this.prop.rfid_id) {
        return this.$message.error('请刷卡');
      }
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.compDialogVisible = true;
        }
      });
    },
    compDialog() {
      this.compDialogVisible = false;
      let form = {};
      form.rfid_id = this.prop.rfid_id;
      form.rfid_comp_id = this.prop.rfid_comp_id;
      form.user_id = this.prop.user_id;
      // form.stff_id = this.prop.stff_id;
      // form.stff_name = this.prop.stff_name;
      form.user_rfid_no = this.prop.user_rfid_no;
      form.rfid_comp_phr = this.form.rfid_comp_phr;
      form.rfid_comp_id = this.form.rfid_comp_id;
      form.rfid_take_stff_names = this.form.rfid_take_stff_names;
      form.card_user_id = this.form.card_user_id ? this.form.card_user_id : this.$cookies.get('userInfo').user_id;
      form.stff_id = this.form.stff_id ? this.form.stff_id : this.$cookies.get('userInfo').stff_id;
      form.stff_name = this.stffList2.find(item => item.stff_id === form.stff_id).stff_name;
      form.user_id = this.stffList.find(item => item.stff_id === form.stff_id).user_id;
      form.list = this.$refs.subTable.tableData.filter(x => (x.rfid_comp_id ? true : !x.rfid_comp_id && !x.destroy_flag));
      post(rfidAPI.edit_comp, form)
        .then(res => {
          if (res.data.code !== 0) {
            return this.$message.error(res.data.msg);
          }
          this.$message.success(res.data.msg);
          this.$refs.form.resetFields();
          this.$emit('empty');
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    compPhrChange() {
      // this.form.rfid_comp_phr
    },
    keepNum99(val) {
      let keepTNum = helper.keepTNum1(val);
      if (keepTNum > 99) {
        this.$message.warning('输入范围0～99超出最大限度');
        return 99;
      } else {
        return keepTNum;
      }
    }
  },
  mounted() {
    this.$EventBus.$on('comp', () => {
      this.form.rfid_comp_phr = '';
      this.form.rfid_comp_id = '';
      this.form.card_user_id = '';
      this.form.stff_id = '';
      this.form.rfid_take_stff_names = [];
    });
    this.$EventBus.$on('compEmit', res => {
      this.form.rfid_comp_phr = res.rfid_comp_phr;
      if (!res.matchClickStatus) {
        this.form.rfid_comp_id = res.rfid_comp_id;
      }
      this.form.card_user_id = res.card_user_id;
      this.form.stff_id = res.stff_id;
      this.form.rfid_take_stff_names = res.rfid_take_stff_names;
      if (!this.$refs.compRef) {
        return;
      } else {
        this.$refs.compRef.focus();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.compForm .el-form-item {
  margin-bottom: 10px;
}
.compForm {
  width: 90%;
  margin: 0 auto;
  min-width: 500px;
}
::v-deep .compForm .el-form-item__label {
  font-size: $font-max;
}
::v-deep .compForm .el-input {
  font-size: $font-max;
  height: 60px;
}
::v-deep .compForm .el-input input {
  height: 60px;
}
::v-deep .el-form-item__error {
  font-size: 18px;
  margin-bottom: 2px;
}
</style>
